// Sport + Game route for /bet/sport/:sportId/game/:gameId
// Provides both params to parent layout via useMatches — no visible UI here
export default function BetSportGame() {
  return null;
}
